// @flow
import React, { Component } from "react";
import HeroUnit from "./Components/LandingPage/HeroUnit";
import FeaturesUnit from "./Components/LandingPage/FeaturesUnit";
import LeadGeneratorUnit from "./Components/LandingPage/LeadGeneratorUnit";
import PartnerLeadGeneratorUnit from "./Components/LandingPage/PartnerLeadGeneratorUnit";
import TestimonialsUnit from "./Components/LandingPage/TestimonialsUnit";

type PropsType = {
  translate: string => void
};

type StateType = {};

class LandingPage extends Component<PropsType, StateType> {
  render() {
    return (
      <div>
        <HeroUnit {...this.props} />

        <main className="main-content">
          <FeaturesUnit {...this.props} />
          <LeadGeneratorUnit {...this.props} />
          <PartnerLeadGeneratorUnit {...this.props} />
          <TestimonialsUnit {...this.props} />
        </main>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/LandingPage.js